module.exports = __webpack_public_path__ + "img/Alhayat.5522c022.png";